import { LinkItemText } from "./link-item-text";
import { LinkRoot } from "./link-root";

export const Link = {
  item: LinkRoot,
  text: LinkItemText
}
